export default "https://vulcan.houseofdev.tech/loykathong/api";
